import { UploadOutlined } from '@ant-design/icons';
import {
  Button, Upload, UploadProps,
} from 'antd';
import { genTestID } from '../../utils/utils';

interface TaggedFileUploadOwnProps extends UploadProps{
  tag:string
}

const TaggedFileUpload = (props:TaggedFileUploadOwnProps) => {
  const { tag } = props;

  return (
    <Upload data-testid={genTestID('fileUpload', tag)} {...props}>
      <Button icon={<UploadOutlined />}>Click to Upload</Button>
    </Upload>
  );
};

export default TaggedFileUpload;
